export default __webpack_public_path__ + "static/media/katie_b.2280ec20.PNG";